export const messages = {
    chronologicalSequenceOperations: [
        'Хронологическая последовательность операций нарушена. Проверьте поля: ',
        'The chronological sequence of operations is broken. Check fields: ',
    ],
    clickBack: ['Для выхода нажмите ещё раз НАЗАД', 'Please click BACK again to exit.'],
    configuringShotViewNavRoute: [
        'Параметры используются для настройки сокращённого режима рабочего плана полёта.',
        'This settings are used to configuring the short view for navigation route panel',
    ],
    confirmAnotherCfp: [
        'Вы уже выбрали CFP, и он еще не завершен. Выбор другого CFP удалит все введённые данные о навигационных точках. Вы все еще хотите выбрать другой CFP?',
        'You have already selected the CFP, and it has not been completed yet. Selecting another CFP will delete all the entered data about the navigation points. Would you still like to select another CFP?',
    ],
    confirmChangeCurrentDirection: [
        'Вы действительно хотите изменить спрямление? Пожалуйста, выберите новый пункт назначения',
        'Do you really want to change current direction? Please, select new destination.',
    ],
    confirmDirectToPoint: [
        'Вы действительно хотите добавить спрямление из ППМ "{{pointName}}"? Выберите ППМ, до которого будет произведено спрямление.',
        'Do you really want to perform the operation "Direct to" from the point "{{pointName}}"? Please, select destination for direction.',
    ],
    confirmLogout: [
        'Вы уверены, что хотите выйти из системы? Все несохранённые данные будут потеряны',
        'Are you sure you want to logout? All unsaved data will be lost.',
    ],
    confirmResetChanges: ['Вы хотите сбросить ВСЕ изменения для этого участка?', 'Do you want to reset ALL changes for this leg?'],
    currentLegNotFirstInFlightTask: [
        `Текущий участок не является первым в задании. По умолчанию, если не было отдыха, время начала работы на участке должно совпадать со временем окончания работы на предыдущем участке.
         Если Вы хотите добавить отдых, введите время окончания отдыха.`,
        `The current leg is not the first in the flight task. By default, if there was no rest, then the beginning of working time on the leg should coincide with the end leg time on the previous one.
         If you want to add a rest, enter end time of the rest as value.`,
    ],
    downloadAirportService: ['Загрузка технологических операций...', 'Downloading process operations...'],
    downloadAttachment: ['Загрузка вложения...', 'Downloading attachment...'],
    downloadCheckList: ['Загрузка данных контрольного списка...', 'Downloading check list data...'],
    downloadDefects: ['Загрузка ограничений ВС "{{name}}"...', 'Downloading AC limitation "{{name}}"...'],
    downloadDocument: ['Загрузка документа "{{name}}"...', 'Downloading document "{{name}}"...'],
    downloadDocuments: ['Загрузка документов...', 'Downloading documents...'],
    downloadLibrary: ['Загрузка элементов библиотеки...', 'Downloading library items...'],
    downloadPrefix: ['Загружено на устройство ', 'Downloaded to device at '],
    downloadReports: ['Загрузка докладов...', 'Downloading reports...'],
    downloadTask: ['Загрузка данных по заданию...', 'Downloading task data...'],
    editCrewDutyTimeError: ['Ошибка редактирования рабочего времени экипажа', 'Edit crew duty time error'],
    enableAltimeterReconciliation: ['Включить сверку высотомера', 'Enable altimeter reconciliation'],
    enableFuelReconciliation: ['Включить сверку топлива', 'Enable fuel reconciliation'],
    filesDelete: ['Все файлы успешно удалены', 'All files are successfully deleted'],
    fileSendSuccess: ['Файл успешно отправлен', 'File sent successfully'],
    loadTaskList: ['Загрузка списка заданий...', 'Loading task list...'],
    locationAdvisory: ['* информация о местоположении только для справки', '* location information for advisory only'],
    login: ['Вход...', 'Login...'],
    logout: ['Выход...', 'Logout...'],
    minimalPointDetectionDistance: ['Минимальное допустимое расстояние для обнаружения точки', 'The minimal point detection distance'],
    noAcLimitations: ['Ограничения ВС отсутствуют', 'There are not any AC limitations'],
    noAirportOperations: ['Технологические операции отсутствуют', 'There are not any operations'],
    noAttachments: ['Вложения отсутствуют', 'There are not any attachments'],
    noCabinLayoutForAircraft: [
        'Схема рассадки отсутствует. Используйте табличный вид для просмотра списка пассажиров.',
        'There is not cabin layout for aircraft. Use table view for passenger list.',
    ],
    noCrewInfo: ['Информация об экипаже отсутствует', 'There is no crew information'],
    noDocuments: ['Документы отсутствуют', 'There are not any documents'],
    noAvailableInfoForLeg: ['Информация на текущем участке недоступна', 'Information on the current leg is not available'],
    noInfoForLeg: ['Информация по участку отсутствует', 'There are not information for leg'],
    noLegsSending: ['Нет участков для отправки', 'There are not legs for sending'],
    noLibraryItems: ['Элементы библиотеки отсутствуют', 'There are not any library items'],
    noOFPs: ['OFP отсутствуют', "There are not any OFP's"],
    noPointsToDirect: ['Нет точек для спрямления', 'There are not any points to direct'],
    noRecords: ['Нет записей', 'No records'],
    noReports: ['Доклады отсутствуют', 'There are not any reports'],
    noSelectedCfpForAc: [
        'Для данного ВС нет телеграммы CFP или она ещё не выбрана',
        "There is no CFP telegram for this aircraft or hasn't been selected yet",
    ],
    noTelegramForAc: ['Для данного ВС нет телеграммы с кодом {{code}}', 'There is no {{code}} telegram for this aircraft'],
    removeDocuments: ['Удаление документов...', 'Removing documents...'],
    repeatLastAction: ['Попробуйте повторить последнее действие', 'Try to repeat last action'],
    sendSingReport: ['Отправка подписей и докладов...', 'Sending signs and reports...'],
    startLegCannotEarlierEndPrevious: [
        'НАЧАЛО работы на участке не может быть раньше окончания предыдущего рабочего времени',
        'START LEG cannot be earlier than the end of the previous working time.',
    ],
    swipeToChangeStatus: ['Проведите пальцем по элементу, чтобы изменить его статус', 'Swipe the item to change the status.'],
    tapToCheckAltitude: ['Нажмите для проверки высоты', 'Tap to check altitude'],
    tapToCheckFuel: ['Нажмите для проверки топлива', 'Tap to check fuel'],
    tapToConfirmSign: ['Для подтверждения необходимо подписать здесь и нажать ОТПРАВИТЬ', 'To confirm you should sign here and tap Ok'],
    uploadingData: ['Загрузка данных...', 'Uploading data...'],
    usingLatestVersion: ['Вы используете актуальную версию приложения.', 'You are using the latest version of the application.'],
};
